import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'

// form save api integration
export async function addSalary(InputField: {
  date: string
  user: string
  band: string
  salaryType: string
  salaryStructure: string
  annualPackage: string
  salaryStructureValues: any
}) {
  const {token, tenantId} = setupAxios()

  const res = await fetch(API_BASE_URL + `/salary`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      date: InputField.date,
      user: InputField.user,
      band: InputField.band,
      salaryType: InputField.salaryType,
      salaryStructure: InputField.salaryStructure,
      annualPackage: InputField.annualPackage,
      salaryStructureValues: InputField.salaryStructureValues,
    }),
  })
  return await res.json()
}

//edit by id
export async function updateSalaryById(
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  id: string
) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/salary/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      date: InputField.date,
      user: InputField.user,
      band: InputField.band,
      salaryType: InputField.salaryType,
      salaryStructure: InputField.salaryStructure,
      annualPackage: InputField.annualPackage,
      salaryStructureValues: InputField.salaryStructureValues,
    }),
  })
  return await res.json()
}

//   get Salary

export async function getSalarys() {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/salary`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}

//   delete salary

export async function deleteSalarys(id: string) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/salary/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })

  if (res.status === 202) {
    return {statusCode: 202, message: 'Record deleted successfully'}
  }

  const data = await res.json()
  return data
}

//getSalarybyid

export async function getSalarysById(userId: string | undefined) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/salary/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}

// get salary data by user id
export async function getSalaryDataByUserId(userId: string | undefined) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/salary/salarydata/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  if (!res.ok) {
    throw new Error('Network response was not ok')
  }
  return await res.json()
}

export async function getUserSalaryById(id: string | undefined, currentUser: any) {
  const {token, tenantId} = setupAxios()
  const response = await fetch(`${API_BASE_URL}/salary/salary/${id ?? currentUser?.id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export async function getBandDataByUserId(userId: string) {
  const {token, tenantId} = setupAxios()

  const response = await fetch(`${API_BASE_URL}/${userId}/band`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await response.json()
}
